// extracted by mini-css-extract-plugin
module.exports = {"ctaBlock":"cta_ctaBlock__iXsYL","or":"cta_or__Oeebd","ctaHeading":"cta_ctaHeading__wWUnB","qr":"cta_qr__lJ4lF"};